import React from "react";
import { connect } from "react-redux";

import { PageWrapper } from "../../../shared/layout";
import { Tabs, BarLoader } from "../../../shared/widgets";
import { style1 as useStyles } from "../../../styles/makeStyles";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import IssueList from "./IssueList";

function BalanceLoaded(props) {
  const { location } = props;
  const classes = useStyles();
  const [value, setValue] = React.useState("issueCard");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const busNumber = location?.state?.busNumber || "";

  return (
    <div className={classes.root}>
      <PageWrapper>
        <PageWrapper.Header heading={`${busNumber}`} showBackArrow hideS />
        <div>
          <PageWrapper.Header hideS>
            <div className="dataTables_length tabWrapper">
              <Tabs
                tabs={[
                  { key: "issueCard", display: "Total Issue Card Amount" },
                  { key: "rechargeCard", display: "Total Recharge Card Amount" },
                ]}
                activeTab={value}
                onTabSelection={(key) => {
                  handleChange("true", key);
                }}
              />
            </div>
          </PageWrapper.Header>
        </div>
        <div>
          <BarLoader scope="header" />
          {value === "issueCard" ? <IssueList componentType="card" /> : <IssueList componentType="recharge" />}
        </div>
      </PageWrapper>
    </div>
  );
}

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = (dispatch) => ({
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BalanceLoaded);
